<template>
  <div
    class="serviceimage"
    :style="{ backgroundImage: `url(${serviceimage})` }"
    v-show="!showchatwindow"
    @click="addUserToChatList"
  ></div>
  <div
    class="servicechatwindow"
    :style="{ width: showchatwindow ? '300px' : '0px' }"
  >
    <!-- 聊天窗口 -->
    <div class="flexbox-c servicechatcontent">
      <div class="empty" style="margin-top: 161px" v-if="!service.id"></div>
      <div class="flexbox servicechatcontentbody" v-else>
        <!-- 头部 -->
        <div class="flexbox chatheader">
          <div class="userheader">
            <img :src="imgurl + service.avatar" />
            <i
              v-if="+service.vip != 0"
              class="iconfont icon-V vip"
              :style="{ color: +service.vip == 1 ? 'silver' : 'gold' }"
            ></i>
          </div>
          <div class="flexbox username">{{ service.nickname || service.username }}</div>
          <div class="optionbox">
            <i class="el-icon-close close" @click="showchatwindow = false"></i>
          </div>
        </div>
        <chat-connection-status />
        <!-- 聊天内容 -->
        <el-scrollbar noresize @scroll="chatwindowscrollevent">
          <div class="flexbox history" @click="queryHistory">
            {{ historyLabel }}
          </div>

          <div class="flexbox chatbody" v-if="service">
            <chat-content
              v-for="item of messages"
              :key="item.client_msg_id || item.id"
              :data="item"
            />
          </div>
        </el-scrollbar>

        <!-- 输入框 -->
        <div class="flexbox-s chatinputbox" v-if="true">
          <el-input v-model="chatcontent" @keydown.enter="send"></el-input>
          <div class="flexbox opratebox">
            <!-- 翻译按钮 -->
            <!-- <div class="flexbox iconbox" @click.stop="showtrans = true">
              <i class="iconfont icon-zhuanhuan" style="font-size: 20px"></i>
            </div> -->
            <!-- 图片按钮 -->
            <div class="flexbox iconbox" @click="$refs.fileinput.click()">
              <i class="iconfont icon-tupian" style="font-size: 20px"></i>
            </div>
            <!-- 图片文件 -->
            <input
              type="file"
              accept="image/*"
              v-show="false"
              @change="fileChange"
              ref="fileinput"
            />
            <!-- 表情按钮 -->
            <div class="flexbox iconbox" @click.stop="showexpress = true">
              <i
                class="iconfont icon-biaoqing"
                style="color: #eedd55; font-size: 20px"
              ></i>
            </div>
            <!-- 发送按钮 -->
            <div class="flexbox sendbtn" @click="send">
              {{ $t("global.send") }}
            </div>
          </div>
          <!-- 表情框 -->
          <div class="flexbox expressbox">
            <img
              class="img"
              v-for="(item, index) of expressionStrList"
              :key="index"
              :src="expressionSource[item]"
              @click.stop="pushexp(item)"
              v-show="showexpress"
            />
          </div>
          <!-- 翻译框 -->
          <div class="flexbox transbox" v-show="showtrans" @click.stop>
            <Trans :id="service.uid" height="100px" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="false">{{ curItemlist }}</div>
</template>

<script>
import serviceimage from "../../assets/images/customer_service.png"
import ChatContent from "../ChatContent.vue"
import ChatConnectionStatus from "../ChatConnectionStatus.vue"
import chatWindowHistory from "../../util/chatWindowHistory";
import Expression from "../Expression.vue"
import Trans from "../Trans.vue"
import { imgurl } from "../../common/project.config";
import { expressionSource, expressionStrList } from "../../util/expression"
export default {
  mixins: [chatWindowHistory],
  data () {
    return {
      serviceimage,
      showchatwindow: false,

      // 输入内容
      chatcontent: '',
      // 表情数据
      expressionStrList,
      expressionSource,
      showexpress: false,

      lastScrollPos: 0,
      scrollAffix: false,

      showtrans: false,
    }
  },
  components: {
    ChatConnectionStatus,
    ChatContent,
    Expression,
    Trans,
  },
  computed: {
    messages() {
      return this.$store.getters.chatMessages(this.service.uid);
    },
    service () {
      return this.$store.state.Chat.service;
    },
    curItemlist () {
      if (!this.scrollAffix) {
        setTimeout(() => {
          let view_container = document.querySelector('.servicechatwindow .el-scrollbar__wrap');
          if (view_container) {
            view_container.scrollTo(0, view_container.scrollHeight - view_container.clientHeight);
          }
        })
      }
      return this.$store.state.Chat.service.list ? this.$store.state.Chat.service.list.length : 0;
    }
  },
  methods: {
    addUserToChatList () {
      this.$store.commit('addUserToGlobalChatListFromUser', this.$store.state.Chat.service);
    },
    // 发送图片
    fileChange(e) {
      e.preventDefault();
      const files = e.target.files || (e.dataTransfer && e.dataTransfer.files) || [];
      const file = files[0];
      const receiverId = this.service.uid;
      e.target.value = "";
      if (!file) return false;
      return this.$store.dispatch("sendChatImage", { file, receiver_id: receiverId });
    },
    // 插入表情
    pushexp (item) {
      this.chatcontent += "[" + item + "]";
    },
    // 发送聊天信息
    async send() {
      const text = this.chatcontent;
      if (!text.trim()) {
        this.$message.error(this.$t("tips.contentcantempty"));
        return false;
      }
      const sent = await this.$store.dispatch("wssend", {
        opt: 1, uid: this.$store.state.User.id, address: this.service.uid,
        txt: text, type: "text", origin: true,
      });
      if (sent && this.chatcontent === text) this.chatcontent = "";
      return sent;
    },
    chatwindowscrollevent () {
      let view_container = document.querySelector('.servicechatwindow .el-scrollbar__wrap');
      if (view_container.scrollHeight - 20 < view_container.scrollTop + view_container.clientHeight) {
        this.scrollAffix = false;
      } else {
        this.scrollAffix = true;
      }
    },

  },
  mounted () {
    document.querySelector('.servicechatwindow').onclick = () => {
      this.showexpress = false;
      this.showtrans = false;
    }
  },
  beforeUnmount () {
    document.querySelector('.servicechatwindow').onclick = null;
  },

}
</script>

<style lang="scss" scoped>
$boderColor: rgba(
  $color: #aaa,
  $alpha: 0.3,
);
$border: 1px solid $boderColor;
.serviceimage {
  position: fixed;
  right: 0;
  bottom: 60px;
  width: 80px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
}
.servicechatwindow {
  position: fixed;
  right: 0;
  bottom: 40px;
  width: 300px;
  height: 400px;
  background-color: #f1f2f3;
  z-index: 2021;
  overflow: hidden;
  transition: width 0.2s;
}
.servicechatcontent {
  width: 100%;
  height: 400px;
  .servicechatcontentbody {
    width: 100%;
    height: 400px;
    flex-direction: column;
    flex-wrap: nowrap;
    .chatheader {
      height: 40px;
      border-bottom: $border;
      padding: 0 15px;
      flex-wrap: nowrap;
      flex-shrink: 0;
      .userheader {
        position: relative;
        width: 30px;
        height: 30px;
        position: relative;
        flex-shrink: 0;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 30px;
          height: 30px;
        }
        .vip {
          position: absolute;
          right: 0px;
          bottom: 0px;
          color: gold;
          font-size: 16px;
        }
      }
      .username {
        font-size: 14px;
        font-weight: bold;
        color: $linkColor;
        justify-content: flex-start;
        padding-left: 10px;
      }
    }
    .history {
      font-size: 12px;
      color: #999;
      cursor: pointer;
    }
    .chatbody {
      width: 300px;
      height: 100%;
      overflow: auto;
    }
    .chatinputbox {
      height: auto;
      flex-shrink: 0;
      border-top: $border;
      .opratebox {
        justify-content: flex-end;
        padding: 5px;
        .iconbox {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-right: 10px;
        }
        .sendbtn {
          width: auto;
          height: 20px;
          padding: 0 5px;
          background-color: $themeColor;
          border-radius: 3px;
          border: 1px solid #333;
          color: #fff;
          cursor: pointer;
          font-size: 12px;
        }
      }
    }
  }
  .expressbox {
    width: 100%;
    height: auto;
    background-color: #fff;
    justify-content: flex-start;
    align-content: flex-start;
    overflow: hidden;
    img {
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
  }
  .close {
    cursor: pointer;
  }
}
</style>
